import { jwtDecode } from 'jwt-decode';
import storage from './storage';

export interface IdTokenPayload {
  sub: string;
  username: string;
  email: string;
  name: string;
  avatar_url: string;
  is_verified: boolean;
  // …other claims you care about
}

/**
 * Reads the stored ID token, decodes it, and returns the payload.
 * Returns `null` if there’s no token or it fails to decode.
 */
export function getUserFromIdToken(): IdTokenPayload | null {
  const raw = storage.getIdToken();
  if (!raw) return null;

  try {
    return jwtDecode<IdTokenPayload>(raw);
  } catch {
    console.error('Could not decode ID token');
    return null;
  }
}
